import { render, staticRenderFns } from "./ModuleReload.vue?vue&type=template&id=95180cb8&scoped=true&"
import script from "./ModuleReload.vue?vue&type=script&lang=js&"
export * from "./ModuleReload.vue?vue&type=script&lang=js&"
import style0 from "./ModuleReload.vue?vue&type=style&index=0&id=95180cb8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95180cb8",
  null
  
)

export default component.exports